import * as ng from 'angular';
import { DropzoneBase64 } from './drop-zone-base64.directive';


export const DropzoneBase64Module: string =
    ng.module('dropzone-base64', [
    ])
        .directive('dropzoneBase64', DropzoneBase64)
        .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/directives/drop-zone-base64/drop-zone-base64.module.ts